/// <reference path="../typings/index.d.ts" />
namespace App.Modulos {
  export class Planos {
    public static inicializar() {
      var plano = new App.Planos();
      plano.inicializarEventos();
    }
  }
}

namespace App {
  export class Planos {
    private ajax: IAjax;

    private elementoLinkPagamento: JQuery = $(".link-pagamento");
    private elementoAcaoFormularioLinkPagamento: JQuery = $("#formLinkPagamento");
    private elementoBotaoAssinarComCartao: JQuery = $(".mercadopago-button");
    private elBtIncrement: JQuery = $(".increment");
    private elBtDecrement: JQuery = $(".decrement");

    private elInputQuantidadeContas: JQuery = $(".quantidadeContas");
    private elAbaMeses: JQuery = $(".aba-meses");
    private elSelectCurrency: JQuery = $("#currency");

    private elBtMaisInfoVCloube: JQuery = $(".btn-mais-informacoes-vCloube");
    private elBtDuvidaSobrePagamento: JQuery = $(".duvida-sobre-pagamento");

    private elBtAumentar: JQuery = $(".aumentarQuantidade");
    private elBtDiminuir: JQuery = $(".diminuirQuantidade");
    private elCampoNumero: JQuery = $(".numero");
    private qtdMaxContas: number = 100000;
    private elSectionGerenciarPlano: JQuery = $("#sectionGerenciarPlano");

    //INICIO DADOS PIX

    private btnGerarPix: JQuery = $(".btnGerarPix");

    private qrImagem: JQuery = $(".pixQrImagem");
    private pixDescricaoValor: JQuery = $(".pixDescricaoValor");
    private btnCopiarPix: JQuery = $(".btnCopiarPix");
    private copiaCola: JQuery = $(".pixCopiaCola");
    private expiraEm: JQuery = $(".expiraEm");
    private msgCallbackPix: JQuery = $(".msg-callback-pix");

    private jaProcessado: boolean = false;
    private pollingInterval: any = null;
    //FIM DADOS PIX

    private simulacaoConversaoPro: any = null;
    private urlSimularConversaoPro: string = '';
    private urlConfirmarConversaoPro: string = '';

    private planos: IPlano[] = null;
    private util: any = null;
    private promoRestoTemporada: boolean = false;
    private diasRestoTemporada: number = 0;
    private descontoTerceiro: number = 0;
    private terceiroMeses: number = 12;
    private ehPlanoRestoTemporadaAtual: boolean = false;
    private contasAtuais: number = 0;
    private planoAtivoPago: boolean = false;
    private tipoPrecoTemporada: string = 'promocao_final_temporada';
    private tipoPrecoReferenciaTemporada: string = 'valor_padrao';
    private labelTemporada: string = 'Final de Temporada';

    private dadosPlanoUpgrade: {
      nomePlano: string; quantidadeContas: any; idPlano: number; tipoPrecoPlano: string; saldo: number; valorPlanoComDesconto: string
      valorUpgradeFormatado: string; precoPlanoFormatado: string; saldoFormatado: string; descontoPlano: string,tipoPrecoPlanoDescricao: string,valorUpgrade: number,pctDescontoTemporada: number
    } = { nomePlano: '',quantidadeContas: 0,idPlano: 0,tipoPrecoPlano: '',saldo: 0,valorUpgradeFormatado: '',precoPlanoFormatado: '',saldoFormatado: '',descontoPlano: '',valorPlanoComDesconto: '',tipoPrecoPlanoDescricao: '',valorUpgrade: 0,pctDescontoTemporada: 0 };

    public inicializarEventos() {
      this.elementoLinkPagamento.on('click',(e) => { this.aoIniciarFormularioLinkPagamento(e); });
      this.ajax = new App.Ajax();
      this.elementoBotaoAssinarComCartao.on('click',() => { this.ajax.recarregarNaoLogado("/login") });
      this.elBtIncrement.on('click',(e) => { this.aoIncrementarValor(e); });
      this.elBtDecrement.on('click',(e) => { this.aoDecrementarValor(e); });

      this.elInputQuantidadeContas.on('change',(e) => { this.aoAlterarQuantidadeContas(e); });
      this.elAbaMeses.on('click',(e) => { this.aoAlterarAbaMeses(e); });
      this.elSelectCurrency.on('change',(e) => { this.aoAlterarCurrency(e); });
      this.elBtMaisInfoVCloube.on('click',(e) => { this.aoClicarBtnMaisInformacoes(e); });
      this.elBtDuvidaSobrePagamento.on('click',(e) => { this.aoClicarDuvidaSobrePagamento(e); });

      this.elBtAumentar.on('click',(e) => { this.aoExecutarAcao(e,+5); });
      this.elBtDiminuir.on('click',(e) => { this.aoExecutarAcao(e,-5); });
      this.elCampoNumero.on('blur',(e) => { this.aoExecutarAcao(e); });
      this.elCampoNumero.on('keydown',(e) => {
        let timer;
        clearTimeout(timer);
        timer = setTimeout(() => {
          this.aoExecutarAcao(e);
        },1000); // meio segundo sem teclar
      });
      //INÍCIO DADOS PIX
      this.btnGerarPix.on('click',(e) => { this.gerarQrCodePix(e); });
      this.btnCopiarPix.on('click',(e) => { this.copiarCodigoPix(e); });
      this.qrImagem.on('click',(e) => this.copiarCodigoPix(e));
      //FIM DADOS PIX

      $('.btnSimularConversaoPro').on('click',(e) => { this.simularConversaoPro(e); });
      $('#convConfirmarCheck').on('change',(e) => { this.aoAlterarConfirmacaoConversaoPro(e); });
      $('#btnConfirmarConversaoPro').on('click',(e) => { this.confirmarConversaoPro(e); });
      $('#modalConversaoPlanoPro').on('hidden.bs.modal',() => { this.resetModalConversaoPro(); });

      this.util = new Util();
      this.planos = this.elSectionGerenciarPlano.data("planos");
      this.promoRestoTemporada = String(this.elSectionGerenciarPlano.data("promo-resto-temporada") || "0") === "1";
      this.diasRestoTemporada = Number(this.elSectionGerenciarPlano.data("dias-resto-temporada") || 0);
      this.descontoTerceiro = Number(this.elSectionGerenciarPlano.data("desconto-terceiro") || 0);
      this.terceiroMeses = Number(this.elSectionGerenciarPlano.data("terceiro-meses") || 12);
      this.ehPlanoRestoTemporadaAtual = String(this.elSectionGerenciarPlano.data("eh-plano-resto-temporada") || "0") === "1";
      this.contasAtuais = Number(this.elSectionGerenciarPlano.data("contas-atuais") || 0);
      this.planoAtivoPago = String(this.elSectionGerenciarPlano.data("plano-ativo-pago") || "0") === "1";
      this.tipoPrecoTemporada = String(this.elSectionGerenciarPlano.data("tipo-preco-temporada") || "promocao_final_temporada");
      this.tipoPrecoReferenciaTemporada = String(this.elSectionGerenciarPlano.data("tipo-preco-referencia-temporada") || "valor_padrao");
      this.labelTemporada = String(this.elSectionGerenciarPlano.data("label-temporada") || "Final de Temporada");
      this.aoEnviarContatoComprovante();
      this.temPixPendente();
    }

    private obterPeriodoSelecionadoNaAba(abaAtual: JQuery): { meses: number; dias: number; restoTemporada: boolean } {
      const idAba = String(abaAtual.attr('id') || '');
      if (this.promoRestoTemporada && idAba === 'tab-resto-temporada') {
        return {
          meses: this.terceiroMeses,
          dias: this.diasRestoTemporada,
          restoTemporada: true
        };
      }
      return { meses: 1,dias: 0,restoTemporada: false };
    }

    private atualizarUiPeriodoNaAba(abaAtual: JQuery, restoTemporada: boolean) {
      const periodo = this.obterPeriodoSelecionadoNaAba(abaAtual);
      abaAtual.find('.btnGerarPix').each((_, el) => {
        const $btn = $(el);
        $btn.attr('data-quantidade-meses', String(periodo.meses));
        $btn.attr('data-quantidade-dias', String(periodo.dias));
        $btn.data('quantidade-meses', periodo.meses);
        $btn.data('quantidade-dias', periodo.dias);
      });
    }

    private aoIniciarFormularioLinkPagamento(e: JQueryEventObject) {
      this.elementoAcaoFormularioLinkPagamento.find('input[name=nome_plano]').val($(e.target).data('nome-plano'));
      this.elementoAcaoFormularioLinkPagamento.find('input[name=id_plano]').val($(e.target).data('id-plano'));
      this.elementoAcaoFormularioLinkPagamento.find('input[name=valor_plano]').val($(e.target).data('valor-plano'));
    }

    private aoIncrementarValor(e: JQueryEventObject) {
      var campoValor = $(e.currentTarget).parents('.input-group').find('input');
      var campoValorMax = $(e.currentTarget).parents('.input-group').find('input').data('max');
      var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min');
      var campoValorPadrao = $(e.currentTarget).parents('.input-group').find('input').data('default');
      if (App.Util.ehCampoTextoVazio(campoValor)) {
        campoValor.val(campoValorPadrao).trigger('input').trigger('focusout').trigger('change');
        return;
      }

      var valor = App.Util.obterInteiroDaString(campoValor.val());
      if (!$.isNumeric(valor)) {
        return;
      }

      if (valor >= campoValorMax) {
        $(e.currentTarget).prop('disabled',true);
        campoValor.val(campoValorMax).trigger('input').trigger('focusout').trigger('change');;
        return;
      }

      var campoValorIncrementado = App.Util.incrementarValorNumerico(valor);
      campoValor.val(campoValorIncrementado).trigger('input').trigger('focusout').trigger('change');

      if (campoValorIncrementado > campoValorMin) {
        $('.decrement').prop('disabled',false);
      }
    }

    private aoDecrementarValor(e: JQueryEventObject) {
      var campoValor = $(e.currentTarget).parents('.input-group').find('input');
      var campoValorMax = $(e.currentTarget).parents('.input-group').find('input').data('max');
      var campoValorMin = $(e.currentTarget).parents('.input-group').find('input').data('min');
      var campoValorPadrao = $(e.currentTarget).parents('.input-group').find('input').data('default');

      if (App.Util.ehCampoTextoVazio(campoValor)) {
        campoValor.val(campoValorPadrao).trigger('input').trigger('focusout').trigger('change');
        return;
      }

      var valor = App.Util.obterInteiroDaString(campoValor.val());
      if (!$.isNumeric(valor)) {
        return;
      }

      if (valor <= campoValorMin) {
        $(e.currentTarget).prop('disabled',true);
        campoValor.val(campoValorMin).trigger('input').trigger('focusout').trigger('change');
        return;
      }

      var campoValorDecrementado = App.Util.decrementarValorNumerico(valor);
      campoValor.val(campoValorDecrementado).trigger('input').trigger('focusout').trigger('change');

      if (campoValorDecrementado < campoValorMax) {
        $('.increment').prop('disabled',false);
      }
    }

    private aoAlterarQuantidadeContas(e: JQueryEventObject) {
      $('.plano-dinamico').hide();
      $('.plano-dinamico-cloud').hide();
      $('#planoDinamico' + $(e.currentTarget).val() + $('.aba-meses.active').data('quantidadeMeses')).show();
      $('#planoDinamicoCloud' + $(e.currentTarget).val() + $('.aba-meses.active').data('quantidadeMeses')).show();
    }
    private aoAlterarAbaMeses(e: JQueryEventObject) {
      $('.plano-dinamico').hide();
      $('.plano-dinamico-cloud').hide();
      $('#planoDinamico' + this.elInputQuantidadeContas.val() + $(e.currentTarget).data('quantidadeMeses')).show();
      $('#planoDinamicoCloud' + this.elInputQuantidadeContas.val() + $(e.currentTarget).data('quantidadeMeses')).show();
    }
    private aoAlterarCurrency(e: JQueryEventObject) {
      window.location.href = $(e.currentTarget).data('urlRedirect').replace("?",$(e.currentTarget).val());
      return;
    }

    private aoClicarBtnMaisInformacoes(e: JQueryEventObject) {
      $('#mensagem-modal-vcloud').show();
    }

    private aoClicarDuvidaSobrePagamento(e: JQueryEventObject) {
      $('#mensagem-modal-vcloud').hide();
    }

    private aoExecutarAcao(e: JQueryEventObject,incremento: number = 0): void {

      const abaAtual = $(e.currentTarget).closest('.tab-pane');
      const campo = incremento === 0 ? $(e.currentTarget) : abaAtual.find('.area-quantidade-contas input');
      this.processarCampo(campo,incremento);
    }

    private processarCampo(campo: JQuery,incremento: number = 0): void {

      let campoValorMin = campo.data("min");
      let campoValorMax = campo.data("max");
      if (campoValorMax === undefined || campoValorMax === null || campoValorMax === '') {
        campoValorMax = this.qtdMaxContas;
      }
      campoValorMax = Number(campoValorMax);
      let valor = App.Util.obterInteiroDaString(campo.val());

      this.dadosPlanoUpgrade.nomePlano = campo.data("nome-plano");
      this.dadosPlanoUpgrade.idPlano = campo.data("id-plano");
      this.dadosPlanoUpgrade.tipoPrecoPlano = campo.data("tipo-preco-plano");
      this.dadosPlanoUpgrade.tipoPrecoPlanoDescricao = campo.data("tipo-preco-plano-descricao");
      this.dadosPlanoUpgrade.saldo = campo.data("saldo");

      if (!$.isNumeric(valor)) {
        valor = campoValorMin;
      }

      let novoValor = valor + incremento;
      let arredondado = this.arredondarParaMultiplo(novoValor,5);

      if (arredondado < campoValorMin) arredondado = campoValorMin;
      if (arredondado > campoValorMax) arredondado = campoValorMax;

      campo.val(arredondado).trigger("input").trigger("change").trigger("focusout");
      this.dadosPlanoUpgrade.quantidadeContas = Number(campo.val());

      const abaAtual = campo.closest('.tab-pane');
      if (abaAtual.attr('id') === 'tab-conversao-pro') {
        const tipoDescricao = campo.data('tipo-preco-plano-descricao') || this.dadosPlanoUpgrade.tipoPrecoPlanoDescricao || '';
        abaAtual.find('.descricaoPlanoDesejado').text(
          this.montarDescricaoPlanoConversao(
            this.dadosPlanoUpgrade.nomePlano,
            this.dadosPlanoUpgrade.quantidadeContas,
            tipoDescricao
          )
        );
        return;
      }

      this.efetuarCalculoUpgrade(campo);
    }



    private async efetuarCalculoUpgrade(campo: JQuery): Promise<void> {
      try {
        const abaAtual = campo.closest('.tab-pane');
        const periodo = this.obterPeriodoSelecionadoNaAba(abaAtual);
        this.atualizarUiPeriodoNaAba(abaAtual, periodo.restoTemporada);

        const PRECO_PLANO_PADRAO = 'preco_padrao';
        const tipoLookup = this.dadosPlanoUpgrade.tipoPrecoPlano === PRECO_PLANO_PADRAO || this.dadosPlanoUpgrade.tipoPrecoPlano === 'valor_padrao'
          ? 'valor_padrao'
          : this.dadosPlanoUpgrade.tipoPrecoPlano;

        let precoPlanoPadrao = await this.util.getPrecoPlano(this.dadosPlanoUpgrade.idPlano,this.dadosPlanoUpgrade.quantidadeContas,'valor_padrao',this.planos);
        let precoPlanoComDesconto = precoPlanoPadrao;
        let descontoPlano = 0;

        if (periodo.restoTemporada && this.diasRestoTemporada > 0) {
          // Valor = (referência/30)*dias; Total = (tipo temporada/30)*dias
          const precoFidMensal = await this.util.getPrecoPlano(this.dadosPlanoUpgrade.idPlano,this.dadosPlanoUpgrade.quantidadeContas,this.tipoPrecoReferenciaTemporada,this.planos);
          const precoTempMensal = await this.util.getPrecoPlano(this.dadosPlanoUpgrade.idPlano,this.dadosPlanoUpgrade.quantidadeContas,this.tipoPrecoTemporada,this.planos);
          precoPlanoPadrao = (precoFidMensal / 30) * this.diasRestoTemporada;
          precoPlanoComDesconto = (precoTempMensal / 30) * this.diasRestoTemporada;
          descontoPlano = Math.max(0, precoPlanoPadrao - precoPlanoComDesconto);
        } else if (tipoLookup !== 'valor_padrao') {
          precoPlanoComDesconto = await this.util.getPrecoPlano(this.dadosPlanoUpgrade.idPlano,this.dadosPlanoUpgrade.quantidadeContas,tipoLookup,this.planos);
          descontoPlano = precoPlanoPadrao - precoPlanoComDesconto;
        }

        if (!precoPlanoPadrao) {
          $(".valPlanoDesejado").val(0);
          return;
        }

        const baseParaPagar = (tipoLookup !== 'valor_padrao') || periodo.restoTemporada
          ? precoPlanoComDesconto
          : precoPlanoPadrao;
        // Sem plano ativo: não abate saldo (cenário 3). Com plano: abate.
        const saldoAplicavel = (periodo.restoTemporada && !this.planoAtivoPago)
          ? 0
          : this.dadosPlanoUpgrade.saldo;
        let valorUpgrade: any = Math.max(0, baseParaPagar - saldoAplicavel);

        this.dadosPlanoUpgrade.valorUpgrade = valorUpgrade;
        this.dadosPlanoUpgrade.valorUpgradeFormatado = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(valorUpgrade);
        this.dadosPlanoUpgrade.precoPlanoFormatado = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(precoPlanoPadrao);
        this.dadosPlanoUpgrade.saldoFormatado = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(saldoAplicavel);
        this.dadosPlanoUpgrade.descontoPlano = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(descontoPlano);
        this.dadosPlanoUpgrade.valorPlanoComDesconto = new Intl.NumberFormat("pt-BR",{ style: "currency",currency: "BRL",}).format(precoPlanoComDesconto);
        this.dadosPlanoUpgrade.pctDescontoTemporada = precoPlanoPadrao > 0
          ? Math.round((descontoPlano / precoPlanoPadrao) * 100)
          : 0;

        this.preencherViewUpgrade(campo);
      } catch (err) {
        console.error("Erro ao calcular preço do plano:",err);
        $(".valPlanoDesejado").val(0);
      }
    }

    private preencherViewUpgrade(campo: JQuery) {

      const abaAtual = campo.closest('.tab-pane');
      const idAba = abaAtual.attr('id');

      const descricao = (idAba === 'tab-consultar-preco' && this.dadosPlanoUpgrade.tipoPrecoPlanoDescricao) ? ` - ${this.dadosPlanoUpgrade.tipoPrecoPlanoDescricao}` : '';
      abaAtual.find('.descricaoPlanoDesejado').text(`${this.dadosPlanoUpgrade.nomePlano} ${this.dadosPlanoUpgrade.quantidadeContas} contas${descricao}`);



      abaAtual.find('.saldoRestante').text(`${this.dadosPlanoUpgrade.saldoFormatado}`);
      abaAtual.find('.valPlanoDesejado').text(`${this.dadosPlanoUpgrade.precoPlanoFormatado}`);
      abaAtual.find('.valUpgrade').html(`<b>${this.dadosPlanoUpgrade.valorUpgradeFormatado}</b>`);
      if (idAba === 'tab-resto-temporada') {
        const pct = this.dadosPlanoUpgrade.pctDescontoTemporada;
        const labelPct = pct > 0 ? ` (${pct}% de desconto)` : ` (${this.labelTemporada})`;
        abaAtual.find('#desconto').text(`${this.dadosPlanoUpgrade.descontoPlano}${labelPct}`);
        if (pct > 0) {
          abaAtual.find('.pct-desconto-temporada').text(`${pct}% de desconto`).show();
        } else {
          abaAtual.find('.pct-desconto-temporada').hide();
        }
      } else {
        abaAtual.find('#desconto').text(`${this.dadosPlanoUpgrade.descontoPlano} (${this.dadosPlanoUpgrade.tipoPrecoPlanoDescricao})`);
      }
      abaAtual.find('.ValorPlanoDesconto').text(`${this.dadosPlanoUpgrade.valorPlanoComDesconto}`);
      const $btnPix = abaAtual.find('.btnGerarPix');

      $btnPix.attr('data-plano-id',this.dadosPlanoUpgrade.idPlano);
      $btnPix.attr('data-descricao',`${this.dadosPlanoUpgrade.nomePlano} ${this.dadosPlanoUpgrade.quantidadeContas} contas`);
      $btnPix.attr('data-valor-plano',this.dadosPlanoUpgrade.valorUpgrade);
      $btnPix.attr('data-qtd_contas', String(this.dadosPlanoUpgrade.quantidadeContas));
      $btnPix.data('qtd_contas', this.dadosPlanoUpgrade.quantidadeContas);

      if (idAba === 'tab-resto-temporada') {
        const tipoCompra = this.planoAtivoPago ? 'upgrade' : 'novo-plano';
        $btnPix.attr('data-tipo-compra', tipoCompra);
        $btnPix.data('tipo-compra', tipoCompra);
        $btnPix.attr('data-dados-plano-vigente', this.tipoPrecoTemporada);
        $btnPix.data('dados-plano-vigente', this.tipoPrecoTemporada);
      }
    }

    private arredondarParaMultiplo(valor: number,multiplo: number): number {
      return Math.round(valor / multiplo) * multiplo;
    }

    private aoEnviarContatoComprovante(): void {
      const forms = document.querySelectorAll('.contact-form') as NodeListOf<HTMLFormElement>;
      const botoesEnviar = document.querySelectorAll('.bt-enviar-comprovante') as NodeListOf<HTMLButtonElement>;

      Array.from(forms).forEach((form,index) => {
        const botaoEnviar = botoesEnviar[index];
        if (botaoEnviar) {
          form.addEventListener('submit',() => {
            botaoEnviar.disabled = true;
            botaoEnviar.textContent = 'Enviando...';
          });
        }
      });
    }

    private gerarQrCodePix(e: JQueryEventObject) {
      const btnGerarPix = $(e.currentTarget);
      const logado = btnGerarPix.data('logado');

      if (!logado) {
        window.location.href = '/login';
        return;
      }

      const abaAtual = btnGerarPix.closest('.tab-pane');
      const planoId = btnGerarPix.data('plano-id');
      const tipoCompra = btnGerarPix.data('tipo-compra');
      const quantidadeMeses = btnGerarPix.data('quantidade-meses');
      const quantidadeDias = btnGerarPix.data('quantidade-dias');
      const dadosPlanoVigente = btnGerarPix.data('dados-plano-vigente');

      abaAtual.find(this.msgCallbackPix).hide();
      this.estadoBtPix(btnGerarPix,true);

      if (!planoId) {
        alert('Plano inválido');
        return;
      }

      let quantidadeContas: number;

      if (tipoCompra === 'renovacao') {
        quantidadeContas = Number(abaAtual.find('.qtdContasRenovacao').text());
      } else {
        const qtdAba = abaAtual.find('.quantidadeContas').val();
        quantidadeContas = Number(qtdAba != null && qtdAba !== '' ? qtdAba : btnGerarPix.data('qtd_contas'));
      }

      fetch('/pix/gerar-qrcode',{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          plano_id: planoId,
          qtd_contas: quantidadeContas,
          tipo_compra: tipoCompra,
          quantidade_meses: quantidadeMeses,
          quantidade_dias: quantidadeDias,
          dados_plano_vigente: dadosPlanoVigente
        })
      })
        .then(async response => {
          const text = await response.text();
          try {
            return JSON.parse(text);
          } catch (e) {
            console.error('Resposta NÃO é JSON!');
            throw new Error('Resposta inválida do servidor');
          }

        })
        .then((data: IDadosPagamentoPix) => {
          if (!data.success) {
            console.log('Erro ao gerar QR code:',data);
            if (planoId !== 2) {
              this.estadoBtPix(btnGerarPix,false);
              App.Util.exebirSweetAlerta("Error",data.msg,"error");
              return;
            } else {
              this.erroCallbackPix(btnGerarPix,abaAtual,data.msg);
              return;
            }
          }

          this.abrirAbaAguardandoPagamento();
          this.pixDescricaoValor.text(data.descricao_plano);
          this.copiaCola.val(data.qr_code);
          this.expiraEm.text(data.expira_em);

          this.qrImagem.attr('src','https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=' + encodeURIComponent(data.qr_code));

          this.qrImagem.show();

          this.estadoBtPix(btnGerarPix,false);
          $('#modal-pix-loja-planos').modal('show');
          this.verificaSeEfetuouPagamento();
        })
        .catch((error: Error) => {
          console.log('ERROS:',error);
          this.erroCallbackPix(btnGerarPix,abaAtual,error.message);
        });
    }

    private temPixPendente(): void {
      if ($('#pix-pendente').length > 0) {
        $('#modal-pix-loja-planos').modal('show');
        this.verificaSeEfetuouPagamento();
      }
    }

    private verificaSeEfetuouPagamento(): void {

      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }

      this.jaProcessado = false;

      this.pollingInterval = setInterval(() => {
        $.get("/pix/status-atual",(response: any) => {

          if (!this.jaProcessado && response.success && response.ativado) {
            this.jaProcessado = true;

            clearInterval(this.pollingInterval);
            $('#modal-pix-loja-planos').modal('hide');

            setTimeout(() => {

              let timeoutReload = setTimeout(() => {
                location.reload();
              },5000);

              swal({
                title: 'Sucesso!',
                text: 'Seu plano foi ativado com sucesso!',
                type: 'success',
                confirmButtonText: 'Ok'
              }).then(() => {
                clearTimeout(timeoutReload);
                location.reload();
              });

            },500);
          }

        });
      },5000);
    }


    private abrirAbaAguardandoPagamento(): void {
      console.log('abrirAbaAguardandoPagamento');
      $('.area-planos-pix .nav .btn').removeClass('active');
      $('#tab-aguardando-pagamento-tab').closest('li').show();
      $('#tab-aguardando-pagamento-tab').addClass('active');
      $('.tab-pane').removeClass('show active');
      $('#tab-aguardando-pagamento').addClass('show active');
      $('#tab-aguardando-pagamento').show();
      $('.pix-qrcode').show();
    }

    private erroCallbackPix(btnGerarPix: JQuery,abaAtual: JQuery,msg: String): void {
      if (msg) {
        abaAtual.find(this.msgCallbackPix.find('.alert-text').html('<strong>Alerta!</strong> ' + msg));
      } else {
        abaAtual.find(this.msgCallbackPix.find('.alert-text').html('<strong>Alerta!</strong> Sistema de pagamento temporariamente indisponível. Tente novamente mais tarde.'));
      }
      abaAtual.find(this.msgCallbackPix).show();
      this.estadoBtPix(btnGerarPix,false);
    }

    private estadoBtPix(btnGerarPix: JQuery,desativar = false) {

      if (!btnGerarPix.data('html-original')) {
        btnGerarPix.data('html-original',btnGerarPix.html());
      }

      if (desativar) {
        btnGerarPix.prop('disabled',true);
        btnGerarPix.html(
          '<span class="spinner-border spinner-border-sm" role="status"></span> Gerando Pix...'
        );
      } else {
        btnGerarPix.prop('disabled',false);
        btnGerarPix.html(btnGerarPix.data('html-original'));
      }
    }

    private copiarCodigoPix(e: JQueryEventObject): void {
      if (!this.copiaCola) return;
      const texto = this.copiaCola.val() as string;
      const btnGerarPix = $(e.currentTarget);
      console.log("CODIGO::",texto);

      if ((navigator as any).clipboard) {
        (navigator as any).clipboard.writeText(texto)
          .then(() => {
            this.exibirFeedback(btnGerarPix);
          })
          .catch(() => {
            this.fallbackCopy(btnGerarPix);
          });
      } else {
        this.fallbackCopy(btnGerarPix);
      }
    }

    private fallbackCopy(btn: JQuery): void {
      if (!this.copiaCola) return;
      (this.copiaCola[0] as HTMLTextAreaElement).select();
      document.execCommand('copy');
      this.exibirFeedback(btn);
    }

    private exibirFeedback(btn: JQuery): void {
      let msg: HTMLElement | null = null;
      const target = btn.data('target');
      if (target) {
        msg = btn.parent().find(target)[0] as HTMLElement;
      }

      if (!msg) {
        const $area = btn.closest('.tab-pane');
        if ($area.length) {
          msg = $area.find('.pixCopiadoMsg')[0] as HTMLElement;
        }
      }

      if (!msg) {
        const sibling = btn[0].nextElementSibling as HTMLElement;
        if (sibling && sibling.classList.contains('pixCopiadoMsg')) {
          msg = sibling;
        }
      }

      if (!msg) {
        msg = btn.parent().find('.pixCopiadoMsg')[0] as HTMLElement;
      }

      if (!msg) return;

      msg.style.display = 'inline';

      setTimeout(() => {
        msg.style.display = 'none';
      },2000);
    }

    private obterCsrfToken(): string {
      const token = $('meta[name=csrf-token]').attr('content');
      return token ? String(token) : '';
    }

    private montarDescricaoPlanoConversao(nomePlano: string, quantidadeContas: any, tipoDescricao: string): string {
      let descricao = (nomePlano || '') + ' ' + quantidadeContas + ' contas';
      if (tipoDescricao && tipoDescricao !== 'Valor Padrão') {
        descricao += ' - ' + tipoDescricao;
      }
      return descricao;
    }

    private simularConversaoPro(e: JQueryEventObject): void {
      const btn = $(e.currentTarget);
      const abaAtual = btn.closest('.tab-pane');
      const quantidadeContas = Number(abaAtual.find('.quantidadeContas').val());

      this.urlSimularConversaoPro = String(btn.data('url-simular') || '');
      this.urlConfirmarConversaoPro = String(btn.data('url-confirmar') || '');

      if (!quantidadeContas || quantidadeContas < 1) {
        App.Util.exebirSweetAlerta('Atenção','Informe a quantidade de contas do plano destino.','warning');
        return;
      }

      btn.prop('disabled',true);
      const htmlOriginal = btn.html();
      btn.data('html-original',htmlOriginal);
      btn.html('<span class="spinner-border spinner-border-sm" role="status"></span> Simulando...');

      fetch(this.urlSimularConversaoPro,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-TOKEN': this.obterCsrfToken()
        },
        body: JSON.stringify({
          quantidade_contas: quantidadeContas
        })
      })
        .then(async (response) => {
          const text = await response.text();
          let data: any = null;
          try {
            data = JSON.parse(text);
          } catch (err) {
            throw new Error('Resposta inválida do servidor');
          }
          if (!response.ok || !data.success) {
            throw new Error((data && data.msg) ? data.msg : 'Não foi possível simular a conversão.');
          }
          return data;
        })
        .then((data) => {
          this.preencherModalConversaoPro(data.simulacao);
          $('#modalConversaoPlanoPro').modal('show');
        })
        .catch((err) => {
          App.Util.exebirSweetAlerta('Erro',err.message || 'Erro ao simular a conversão.','error');
        })
        .then(() => {
          btn.prop('disabled',false);
          btn.html(btn.data('html-original') || htmlOriginal);
        });
    }

    private preencherModalConversaoPro(simulacao: any): void {
      this.simulacaoConversaoPro = simulacao;
      const planoAtualTxt = simulacao.plano_atual.descricao_completa
        ? simulacao.plano_atual.descricao_completa
        : this.montarDescricaoPlanoConversao(
          simulacao.plano_atual.nome,
          simulacao.plano_atual.quantidade_contas,
          simulacao.plano_atual.tipo_descricao || simulacao.tipo_plano_vigente_descricao
        );
      const planoDestinoTxt = simulacao.plano_destino.descricao_completa
        ? simulacao.plano_destino.descricao_completa
        : this.montarDescricaoPlanoConversao(
          simulacao.plano_destino.nome,
          simulacao.plano_destino.quantidade_contas,
          simulacao.plano_destino.tipo_descricao || simulacao.tipo_plano_vigente_descricao
        );

      const diasRestantes = Number(simulacao.dias_restantes || 0);
      const diasConcedidos = Number(simulacao.dias_concedidos || 0);
      const diasGanhos = Number(
        simulacao.dias_ganhos != null
          ? simulacao.dias_ganhos
          : Math.max(0, diasConcedidos - diasRestantes)
      );
      const labelDia = (n: number) => (n === 1 ? 'dia' : 'dias');
      const resto = Number(simulacao.resto_nao_creditado || 0);

      $('#convSimBeneficioDias').text('+ ' + diasGanhos + ' ' + labelDia(diasGanhos) + ' de acesso');
      $('#convSimPlanoAtual').text(planoAtualTxt);
      $('#convSimPlanoDestino').text(planoDestinoTxt);
      $('#convSimDiasRestantes').text(diasRestantes + ' ' + labelDia(diasRestantes));
      $('#convSimDiasConcedidos').text(diasConcedidos + ' ' + labelDia(diasConcedidos));
      $('#convSimValidadeAtual').text(simulacao.ends_at_formatada || '-');
      $('#convSimNovaValidade').text(simulacao.nova_data_vencimento_formatada || '-');
      $('#convSimSaldoRestante').text(simulacao.saldo_proporcional_formatado || '-');
      $('#convSimSaldo').text(simulacao.saldo_aplicado_formatado || simulacao.saldo_proporcional_formatado || '-');

      const $blocoResidual = $('#convSimBlocoResidual');
      if (resto > 0) {
        $('#convSimValorResidual').text(simulacao.resto_nao_creditado_formatado || '-');
        $blocoResidual.show();
      } else {
        $('#convSimValorResidual').text('-');
        $blocoResidual.hide();
      }

      this.resetConfirmacaoConversaoPro();
    }

    private aoAlterarConfirmacaoConversaoPro(e: JQueryEventObject): void {
      const marcado = $(e.currentTarget).is(':checked');
      $('#btnConfirmarConversaoPro').prop('disabled',!marcado);
    }

    private resetConfirmacaoConversaoPro(): void {
      $('#convConfirmarCheck').prop('checked',false);
      $('#btnConfirmarConversaoPro').prop('disabled',true);
      $('#convSimErro').hide().text('');
    }

    private resetModalConversaoPro(): void {
      this.simulacaoConversaoPro = null;
      this.resetConfirmacaoConversaoPro();
    }

    private confirmarConversaoPro(e: JQueryEventObject): void {
      const btn = $(e.currentTarget);
      if (!this.simulacaoConversaoPro) {
        App.Util.exebirSweetAlerta('Atenção','Simule a conversão antes de confirmar.','warning');
        return;
      }

      if (!$('#convConfirmarCheck').is(':checked')) {
        App.Util.exebirSweetAlerta('Atenção','Confirme explicitamente a operação para continuar.','warning');
        return;
      }

      const simulacao = this.simulacaoConversaoPro;
      btn.prop('disabled',true);
      $('#convSimErro').hide().text('');

      fetch(this.urlConfirmarConversaoPro,{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-TOKEN': this.obterCsrfToken()
        },
        body: JSON.stringify({
          quantidade_contas: simulacao.plano_destino.quantidade_contas,
          confirmado: true,
          id_plano_inscricao: simulacao.id_plano_inscricao,
          id_compra: simulacao.id_compra,
          quantidade_contas_atual: simulacao.plano_atual.quantidade_contas,
          ends_at: simulacao.ends_at
        })
      })
        .then(async (response) => {
          const text = await response.text();
          let data: any = null;
          try {
            data = JSON.parse(text);
          } catch (err) {
            throw new Error('Resposta inválida do servidor');
          }
          if (!response.ok || !data.success) {
            throw new Error((data && data.msg) ? data.msg : 'Não foi possível concluir a conversão.');
          }
          return data;
        })
        .then((data) => {
          $('#modalConversaoPlanoPro').modal('hide');
          App.Util.exebirSweetAlerta(
            'Sucesso',
            data.msg || 'Conversão realizada com sucesso.',
            'success'
          );
          setTimeout(function () {
            window.location.reload();
          },1800);
        })
        .catch((err) => {
          $('#convSimErro').text(err.message || 'Erro ao confirmar a conversão.').show();
          btn.prop('disabled',!$('#convConfirmarCheck').is(':checked'));
        });
    }

  }
}
